import React, { createContext, useContext } from "react";
import useSocket from "../hooks/useSocket";

// Create context to hold the socket instance and its state
const SocketContext = createContext(null);

/**
 * SocketProvider wraps your app and provides socket data to all child components.
 * It utilizes the custom useSocket hook to manage the Socket.io connection.
 */
export const SocketProvider = ({ children }) => {
  const socketData = useSocket();
  return (
    <SocketContext.Provider value={socketData}>
      {children}
    </SocketContext.Provider>
  );
};

/**
 * Custom hook to consume the SocketContext.
 * Must be used within a SocketProvider.
 */
export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocketContext must be used within a SocketProvider");
  }
  return context;
};

export default SocketContext;
